module.exports = __webpack_public_path__ + "static/profile-c549c790ad5409e45f6b3790088800d1.png";